import { resolveCompanySource } from './PrintLabels/printLabelsUtils';

/**
 * @param {string} poType
 * @returns {'purchaseOrderMapId' | 'packagingPurchaseOrderMapId'}
 */
function getMapIdField(poType) {
    return poType === 'PACKAGING' ? 'packagingPurchaseOrderMapId' : 'purchaseOrderMapId';
}

/**
 * @param {object} map
 * @param {string} poType
 * @returns {number | null}
 */
function getMapIdFromRow(map, poType) {
    if (poType === 'PACKAGING') {
        return map.packagingPurchaseOrderMapId ?? null;
    }

    return map.purchaseOrderMapId ?? null;
}

/**
 * @param {object[]} purchaseOrderMaps
 * @param {string} poType
 * @returns {Map<number, number>}
 */
function buildMapIdToCompanySourceId(purchaseOrderMaps, poType) {
    const index = new Map();

    for (const map of purchaseOrderMaps) {
        const mapId = getMapIdFromRow(map, poType);
        if (mapId != null && map.companySourceId != null) {
            index.set(mapId, map.companySourceId);
        }
    }

    return index;
}

/**
 * @param {Object} params
 * @param {Object} params.response
 * @param {string} params.poType
 * @param {object[]} params.purchaseOrderMaps
 * @param {Array<{ id: number, code: string, displayName: string }>} params.companySourceOptions
 * @returns {{ totalCases: number, pallets: Array<{ id: string, lots: Array<{ id: string, caseCount: number, expiresOn: string | null, companySource: object | null }> }> }}
 */
function buildReceivedPrintDataFromApiResponse({ companySourceOptions, poType, purchaseOrderMaps, response }) {
    const mapIdField = getMapIdField(poType);
    const mapIdToCompanySourceId = buildMapIdToCompanySourceId(purchaseOrderMaps, poType);

    const pallets = (response.pallets ?? []).map((pallet) => ({
        id: String(pallet.id),
        lots: (pallet.lots ?? []).map((lot) => {
            const mapId = lot[mapIdField];
            const companySourceId = mapId != null ? (mapIdToCompanySourceId.get(mapId) ?? null) : null;

            return {
                id: String(lot.lotId),
                caseCount: Number(lot.caseCount) || 0,
                expiresOn: lot.expiresOn ?? null,
                companySource: resolveCompanySource(companySourceId, companySourceOptions),
            };
        }),
    }));

    const totalCases = pallets.reduce(
        (sum, pallet) => sum + pallet.lots.reduce((lotSum, lot) => lotSum + lot.caseCount, 0),
        0,
    );

    return {
        totalCases,
        pallets,
    };
}

export { buildReceivedPrintDataFromApiResponse };
